import {Component} from '@angular/core';
import {AppRoutes} from "../../../../../../enums/routes";
import {AnalyticsRouting} from "../../../routes/analytics-routing";
import {PermissionService} from "../../../../../../_auth/permission.service";
import {
  NavbarItemLargeComponent
} from "../../../../../../x-components/navbar-base/navbar-item-large/navbar-item-large.component";
import {
  NavbarContainerComponent
} from "../../../../../../x-components/navbar-base/navbar-container/navbar-container.component";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-navbar-analysis-component',
  templateUrl: './navbar-analysis.component.html',
  imports: [
    CommonModule,
    NavbarItemLargeComponent,
    NavbarContainerComponent
  ],
  styleUrls: ['./navbar-analysis.component.css']
})
export class NavbarAnalysisComponent {
  public outletPaths = {
    [AnalyticsRouting.TimeSelectorView]: [AppRoutes.Analytics, {outlets: {analytics: [AnalyticsRouting.TimeSelectorView]}}],
    [AnalyticsRouting.EventPicker]: [AppRoutes.Analytics, {outlets: {analytics: [AnalyticsRouting.EventPicker]}}],
    [AnalyticsRouting.Index]: [AppRoutes.Analytics, {outlets: {analytics: [AnalyticsRouting.EventPicker]}}],
  }
  protected readonly AnalysisRouting = AnalyticsRouting;

  constructor(public PermissionService: PermissionService) {
  }

}
